/*!
 * KoliBri - The accessible HTML-Standard
 */
import { g as watchString } from './common-D-vggmh2.js';

const validateHref = (component, value, options = {}) => {
    watchString(component, '_href', value, options);
};

export { validateHref as v };
//# sourceMappingURL=href-C9xfRiDr.js.map

//# sourceMappingURL=href-C9xfRiDr.js.map